const link_list = ['some junk', 'some other junk'];

export default link_list;